// extracted by mini-css-extract-plugin
export default {"advantages":"Advantages_advantages__iQeYI","title":"Advantages_title__OARLq","cards":"Advantages_cards__sLIH-"};